// hooks/useExportToExcel.ts
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';

export const useExportToExcel = () => {
  const exportToExcel = (data: any[], fileName = 'export.xlsx') => {
    if (!data || data.length === 0) return;

    // Cria a planilha
    const worksheet = XLSX.utils.json_to_sheet(data);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Dados');

    // Converte para blob
    const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    const dataBlob = new Blob([excelBuffer], { type: 'application/octet-stream' });

    saveAs(dataBlob, fileName);
  };

  return { exportToExcel };
};
